export function isPlainObject(input: any) {
	return input && !Array.isArray(input) && typeof input === "object";
}
